//===============================================================
// IMG CHANGE
//===============================================================

function imgChange(target) {
	//console.log("imgChange:",target)
	let tgt = target;
	if(!target){
		tgt = 'body';
	}
	/* if($('.barbaWrapper > div').length == 2){
		tgt = '.barbaWrapper > div:nth-child(2)';
	} */
	
	$('.iC',tgt).each(function(){
		//console.log(this)
		if(spSizeFlag){
			$(this).attr("src",$(this).attr("src").replace('_pc', '_sp'));
		}else{
			$(this).attr("src",$(this).attr("src").replace('_sp', '_pc'));
		}
	});
	$('.iCjp',tgt).each(function(){
		if(spSizeFlag){
			$(this).attr("src",$(this).attr("src").replace(/_pc\.(png)$/, '_sp.jpg'));
		}else{
			$(this).attr("src",$(this).attr("src").replace(/_sp\.(jpg)$/, '_pc.png'));
		}
	});
	$('.iCpj',tgt).each(function(){
		if(spSizeFlag){
			$(this).attr("src",$(this).attr("src").replace(/_pc\.(jpg)$/, '_sp.png'));
		}else{
			$(this).attr("src",$(this).attr("src").replace(/_sp\.(png)$/, '_pc.jpg'));
		}
	});
}

export {imgChange}